//
import {
  queryList, saveObject,
  getDeleteMenu, getUpdateMenu, getMenuOpList, getExportData
} from './../api';
import {Message} from 'element-ui';

const menu = {
  namespaced: true,
  state: {
    successCode: 200,
    resp: null,
    deleteMenu: null,
    addPermission: null,
    menuPageOpList: null,
    updateMenu: null,
    addMenu: null,
    exportData: null,
  },
  mutations: {
    QUERY_LIST(state, resp) {
      state.resp = resp
    },
    GET_DELETE_MENU(state, data) {
      state.deleteMenu = data
    },
    GET_MENU_PAGE_OP_LIST(state, data) {
      state.menuPageOpList = data;
    },
    GET_UPDATE_MENU(state, data) {
      state.updateMenu = data
    },
    GET_ADD_MENU(state, data) {
      state.addMenu = data;
    },
    GET_EXPORT_DATA(state, data) {
      state.exportData = data;
    }
  },
  actions: {
    async queryList({commit}, obj) {
      let resp = await queryList(obj);
      commit('QUERY_LIST', resp);
    },
    async getDeleteMenu({commit}, obj) {
      let resp = await getDeleteMenu(obj);
      commit('GET_DELETE_MENU', resp);
    },
    async getUpdateMenu({commit}, obj) {
      let resp = await getUpdateMenu(obj);
      commit('GET_UPDATE_MENU', resp);
    },
    async getAddMenu({commit}, obj) {
      let resp = await saveObject(obj);
      commit('GET_ADD_MENU', resp);
    },
    async getOpList({commit}, obj) {
      let resp = await getOpList(obj);
      commit('GET_PAGE_OP_LIST', resp);
    },
    async getMenuOpList({commit}, obj) {
      let resp = await getMenuOpList(obj);
      commit('GET_MENU_PAGE_OP_LIST', resp);
    },
    async getExportData({commit}, obj) {
      let resp = await getExportData(obj);
      commit('GET_EXPORT_DATA', resp);
    },
  }
}

export default menu



// WEBPACK FOOTER //
// ./src/page/auth/menu/store/menu.store.js